export default __webpack_public_path__ + "static/media/uploadCompany.82fa03c6.svg";